import { render, staticRenderFns } from "./gj-dropdown.vue?vue&type=template&id=2b8291a4&scoped=true&"
import script from "./gj-dropdown.vue?vue&type=script&lang=js&"
export * from "./gj-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./gj-dropdown.vue?vue&type=style&index=0&id=2b8291a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8291a4",
  null
  
)

export default component.exports